import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CalendarEventsQuery, CalendarEventsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CalendarEventsQuery)
@Wrapper(CalendarEventsQueryHandlerBase)
export class CalendarEventsQueryHandler {
    public constructor(
        http: Http
    ) {}
}
